define([
	"dojo/_base/array",
	"./TextToolbarSelect",
	"csi/html",
	"csi/locale",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(array,TextToolbarSelect,html,locale,_Plugin,PluginFactory,util) {


	return PluginFactory.declare([TextToolbarSelect, _Plugin], {
		bText: true,
		"class": "svgSelect csi-text-formatting-select-button",
		cssStyle: "paragraph",
		pluginName: "paragraph",
		title: "CanvasParagraph",
		defaultParagraphStyle: "n",

		/**
		 *  Populate paragraph style store with values based on SVG height
		 */
		postMixInProperties: function() {
			this.options = array.map(["n","h1","h2","h3","h4"], function(value, i) {
				var label = locale.resource("CanvasParagraphStyle_" + value.toUpperCase());

				// add styling to dropdown menu
				if (value !== this.defaultParagraphStyle) {
					var span = html.create("span", {
						"class": "csi-canvas-paragraph csi-canvas-paragraph-" + value,
						innerText: label
					});

					label = span.outerHTML;
				}

				return {label: label , value: value};
			});
			this.inherited(arguments);
		},

		/**
		 *  Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function (shapes, shapeAttrs, textAttrs) {
			let value;
			if (shapes && shapes.length && this.editor.isSelectCanvasMode()) {
				value = this.editor.canvasApp.selection.getCommonTextValue(shapes, this.cssStyle, true) || this.defaultParagraphStyle;
			} else {
				value = textAttrs[this.cssStyle] || this.defaultParagraphStyle;
			}

			this.set("value", value, false); 
			return this.inherited(arguments);
		},

		/**
		 * Apply style
		 * @param  {Object} value
		 */
		onChange: function (value) {
			this.editor.setTextStyle(this.cssStyle, value, true);
		}
	});
});
